import apiClient from "@/api/client";
import type {
  PendingSystemMessage,
  RecipientOption,
  SystemMessage,
  SystemMessageFormData,
  SystemMessageReceipts,
} from "../types";

const wrap = <T>(promise: Promise<{ data: { data: T } }>) =>
  promise.then((r) => r.data.data);

export const systemMessagesApi = {
  /** Wysłane przeze mnie (CEO / dev: wszystkie). */
  list: () => wrap<SystemMessage[]>(apiClient.get("/system-messages/")),

  send: (data: SystemMessageFormData) =>
    wrap<SystemMessage>(apiClient.post("/system-messages/", data)),

  recipientOptions: () =>
    wrap<RecipientOption[]>(apiClient.get("/system-messages/recipient-options/")),

  receipts: (id: string) =>
    wrap<SystemMessageReceipts>(apiClient.get(`/system-messages/${id}/recipients/`)),

  /** Wiadomości czekające na moje potwierdzenie (odczyt uruchamia odliczanie). */
  pending: () =>
    wrap<PendingSystemMessage[]>(apiClient.get("/system-messages/pending/")),

  /** Potwierdzenie całej partii pokazanej w jednym oknie (jedno wspólne 30 s). */
  acknowledge: (ids: string[]) =>
    wrap<{ acknowledged: number }>(
      apiClient.post("/system-messages/acknowledge/", { ids }),
    ),
};
